import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import cn from 'classnames';
import { imageSourceBreakpoints } from 'js/breakpoints';

const ImageCollageBlock = ({
  leftTopImage,
  leftBottomImage,
  rightTopImage,
  rightBottomImage,
}) => {
  return (
    <div className="image-collage-block">
      <div className="image-collage-block__container">
        <div className="image-collage-block__col image-collage-block__col_left">
          {leftTopImage && (
            <Image
              {...leftTopImage}
              sources={[
                {
                  width: 327,
                  height: 363,
                  media: imageSourceBreakpoints.xs,
                },
                {
                  width: 348,
                  height: 387,
                  media: imageSourceBreakpoints.s,
                },
                {
                  width: 440,
                  height: 489,
                  media: imageSourceBreakpoints.m,
                },
                {
                  width: 648,
                  height: 720,
                  media: imageSourceBreakpoints.l,
                },
              ]}
              loading="lazy"
              className="image-collage-block__image image_size_collage-left-top"
            />
          )}
          {leftBottomImage && (
            <Image
              {...leftBottomImage}
              sources={[
                {
                  width: leftTopImage ? 277 : 327,
                  height: leftTopImage ? 171 : 202,
                  media: imageSourceBreakpoints.xs,
                },
                {
                  width: leftTopImage ? 244 : 314,
                  height: leftTopImage ? 150 : 193,
                  media: imageSourceBreakpoints.s,
                },
                {
                  width: leftTopImage ? 308 : 396,
                  height: leftTopImage ? 190 : 244,
                  media: imageSourceBreakpoints.m,
                },
                {
                  width: leftTopImage ? 456 : 584,
                  height: leftTopImage ? 280 : 360,
                  media: imageSourceBreakpoints.l,
                },
              ]}
              loading="lazy"
              className="image-collage-block__image image_size_collage-left-bottom"
            />
          )}
        </div>
        <div
          className={cn(
            'image-collage-block__col image-collage-block__col_right',
            {
              'image-collage-block__col_right_reversed':
                !leftTopImage ||
                !leftBottomImage ||
                !rightTopImage ||
                !rightBottomImage,
            }
          )}
        >
          {rightTopImage && (
            <Image
              {...rightTopImage}
              sources={[
                {
                  width: 303,
                  height: 303,
                  media: imageSourceBreakpoints.xs,
                },
                {
                  width: 265,
                  height: 265,
                  media: imageSourceBreakpoints.s,
                },
                {
                  width: 335,
                  height: 335,
                  media: imageSourceBreakpoints.m,
                },
                {
                  width: 480,
                  height: 480,
                  media: imageSourceBreakpoints.l,
                },
              ]}
              loading="lazy"
              className="image-collage-block__image image_size_collage-right-top"
            />
          )}
          {rightBottomImage && (
            <Image
              {...rightBottomImage}
              sources={[
                {
                  width: 327,
                  height: 182,
                  media: imageSourceBreakpoints.xs,
                },
                {
                  width: 348,
                  height: 194,
                  media: imageSourceBreakpoints.s,
                },
                {
                  width: 440,
                  height: 245,
                  media: imageSourceBreakpoints.m,
                },
                {
                  width: 648,
                  height: 360,
                  media: imageSourceBreakpoints.l,
                },
              ]}
              loading="lazy"
              className="image-collage-block__image image_size_collage-right-bottom"
            />
          )}
        </div>
      </div>
    </div>
  );
};

ImageCollageBlock.propTypes = {
  leftTopImage: PropTypes.exact(Image.propTypes),
  leftBottomImage: PropTypes.exact(Image.propTypes),
  rightTopImage: PropTypes.exact(Image.propTypes),
  rightBottomImage: PropTypes.exact(Image.propTypes),
};

export default ImageCollageBlock;
